import React from 'react';
import AgentDashboard from './AgentDashboard';

const DirectEmbroideryDashboard: React.FC = () => {
  const agentConfig = {
    id: 'direct_embroidery',
    displayName: 'Direct Embroidery',
    icon: '/assets/logos/aldo-embroidery.png',
    color: '#f97316',
    description: 'Direct embroidery operations assistant',
    hasTestResults: false
  };

  return <AgentDashboard agentConfig={agentConfig} />;
};

export default DirectEmbroideryDashboard;

